let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("87len")).then(() => parcelRequire('gytUr'));